import { render, staticRenderFns } from "./image_guide_1.vue?vue&type=template&id=08938fef&scoped=true"
import script from "./image_guide_1.vue?vue&type=script&lang=js"
export * from "./image_guide_1.vue?vue&type=script&lang=js"
import style0 from "./image_guide_1.vue?vue&type=style&index=0&id=08938fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08938fef",
  null
  
)

export default component.exports